var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "animationContainer", staticClass: "dashBoardVideoContainer" },
    [
      _c("canvas", {
        ref: "apngCanvas",
        staticClass: "img-fluid",
        attrs: { width: "700", height: "540" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }